// Sinónimos del buscador de momentos · compartido entre landing y wizard
export const SINONIMOS = [
  { t: 'Estrené / compré carro', v: 'D1' }, { t: 'Saqué crédito de vehículo', v: 'D1' }, { t: 'Choqué o tuve un accidente', v: 'D1' }, { t: 'Me robaron el carro', v: 'D1' },
  { t: 'Tembló / hubo un sismo', v: 'D2' }, { t: 'Se agrietó mi casa', v: 'D2' }, { t: 'Terremoto', v: 'D2' },
  { t: 'Nació un hijo', v: 'D3' }, { t: 'Me casé', v: 'D3' }, { t: 'Estoy esperando un bebé', v: 'D3' }, { t: 'Adopté', v: 'D3' },
  { t: 'Cambié de trabajo', v: 'D4' }, { t: 'Renuncié', v: 'D4' }, { t: 'Me independicé', v: 'D4' }, { t: 'Quedé sin empleo', v: 'D4' }, { t: 'Empecé como independiente', v: 'D4' },
  { t: 'Compré casa', v: 'D5' }, { t: 'Me mudé', v: 'D5' }, { t: 'Estrené vivienda', v: 'D5' }, { t: 'Remodelé', v: 'D5' },
  { t: 'Solo estoy revisando', v: 'Sin' }, { t: 'Nada en particular', v: 'Sin' }, { t: 'Otra cosa', v: 'Sin' },
];

export const norm = (s) => String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// code 'D1'..'D5' → ficha del paso momento · 'Sin' → la que no arranca con D
export const tileByMomentoCode = (tiles, code) =>
  tiles.find((t) => (code === 'Sin' ? !String(t.v).startsWith('D') : String(t.v).startsWith(code))) || tiles[0];
